import { gql } from "@apollo/client";

export const COMMENT_QUERY = gql`
  query commentData($documentId: Int!) {
    commentData(documentId: $documentId) {
      documentId
      comments {
        documentCommentId
        freeTxt
        internalTime
        userId
        userName
        stateId
        stateName
      }
    }
  }
`;
